import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import type LeftNavGroupsSchema from '../store/schema/LeftNavGroups';
import { getLeftNavGroupsStore } from '../store/store';
import type GroupNodeViewState from '../store/schema/GroupNodeViewState';
import type RestoreGroupState from '../store/schema/RestoreGroupState';

export default function getLeftNavGroups(mailboxInfo: MailboxInfo): LeftNavGroupsSchema {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);

    const leftNavGroups = getLeftNavGroupsStore().leftNavGroupsByMailboxInfo.get(accountKey);

    if (!leftNavGroups) {
        const defaultLeftNavGroups: LeftNavGroupsSchema = {
            myOrgGroups: [],
            withContextMenuGroup: null,
            hasLoadedFromServer: false,
            loadGroupsError: false,
            groupNodeViewStates: new Map<string, GroupNodeViewState>([]),
            restoreGroupState: new Map<string, RestoreGroupState>(),
        };

        getLeftNavGroupsStore().leftNavGroupsByMailboxInfo.set(accountKey, defaultLeftNavGroups);
        /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion  -- (https://aka.ms/OWALintWiki)
         * Non-null assertions are dangerous, as they can hide bugs from strictness checks. Please remove this usage or replace this line with a justification.
         *	> Forbidden non-null assertion. */
        return getLeftNavGroupsStore().leftNavGroupsByMailboxInfo.get(accountKey)!;
    }

    return leftNavGroups;
}
